let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("iJd4r"), load("9KmkE"), load("hAaCB"), load("4UPrd"), load("eFcy5")]).then(() => parcelRequire('iUJE2'));